<template>
  <div class="row custom-calender hidden">
    <div class="col-md-4 my-1 px-md-3 px-0">
      <b-skeleton height="41px"></b-skeleton>
    </div>
    <div class="col-md-4 my-1 px-md-3 px-0">
      <b-skeleton height="41px"></b-skeleton>
    </div>
    <div class="col-md-4 mt-auto my-1 px-md-3 px-0">
      <b-skeleton height="41px"></b-skeleton>
    </div>
    <div class="col-md-3 col-6 mt-auto my-1 px-md-3 px-0">
      <b-skeleton height="20px"></b-skeleton>
    </div>
  </div>
</template>

<script>
export default {
  name: "DateSelectorSkeleton",
};
</script>

<style lang="scss" scoped></style>
